import { IconePausar, IconeReiniciar, IconeReproduzir } from '../../icones'
import type { Timeline } from '../../useTimeline'

/**
 * Reprodução compacta sobre o canvas: play/pause, reiniciar e o instante em
 * unidades do próprio evento ("4,2 s de 12,9 s"), não em porcentagem — o
 * aluno precisa sentir quanto tempo o evento dura.
 */
export function BarraTimeline({
  timeline,
  duracaoTotal,
  unidade = 's',
  rotulo,
}: {
  timeline: Timeline
  duracaoTotal: number
  unidade?: string
  rotulo: string
}) {
  const formatar = (valor: number) => valor.toLocaleString('pt-BR', { maximumFractionDigits: 1, minimumFractionDigits: 1 })
  return (
    <div className="barra-timeline" role="group" aria-label={`Reprodução: ${rotulo}`}>
      <button
        type="button"
        className="barra-timeline__botao"
        onClick={timeline.alternarReproducao}
        aria-label={timeline.reproduzindo ? 'Pausar' : 'Reproduzir'}
        title={timeline.reproduzindo ? 'Pausar' : 'Reproduzir'}
      >
        {timeline.reproduzindo ? <IconePausar /> : <IconeReproduzir />}
      </button>
      <button type="button" className="barra-timeline__botao" onClick={timeline.reiniciar} aria-label="Reiniciar" title="Reiniciar">
        <IconeReiniciar />
      </button>
      <input
        type="range"
        min="0"
        max="1"
        step="0.001"
        value={timeline.tempo}
        aria-label={`Instante: ${rotulo}`}
        onChange={(e) => timeline.irPara(Number(e.target.value))}
      />
      <span className="barra-timeline__tempo">
        {formatar(timeline.tempo * duracaoTotal)} {unidade} de {formatar(duracaoTotal)} {unidade}
      </span>
    </div>
  )
}
